import { Modal, Table, Typography } from "antd";
import type React from "react";
import type { CognitoUserResponse } from "../utils/apiTestUtils";

interface CognitoUserModalProps {
  visible: boolean;
  onClose: () => void;
  userData: CognitoUserResponse | null;
  loading: boolean;
}

export const CognitoUserModal: React.FC<CognitoUserModalProps> = ({
  visible,
  onClose,
  userData,
  loading,
}) => {
  const columns = [
    {
      title: "Attribute",
      dataIndex: "Name",
      key: "name",
      width: "40%",
      render: (text: string) => {
        // Format attribute names for better readability
        return text.replace(/^(custom:)?/, "").replace(/_/g, " ");
      },
    },
    {
      title: "Value",
      dataIndex: "Value",
      key: "value",
      width: "60%",
      ellipsis: true,
    },
  ];

  return (
    <Modal title="Cognito User Details" open={visible} onCancel={onClose} footer={null} width={700}>
      {loading ? (
        <div className="text-center py-4">Loading user data...</div>
      ) : userData ? (
        <div>
          <div className="mb-4">
            <Typography.Title level={5}>Username: {userData.Username}</Typography.Title>
          </div>
          <Table
            dataSource={userData.UserAttributes}
            columns={columns}
            rowKey="Name"
            pagination={false}
            size="small"
            scroll={{ y: 400 }}
          />
        </div>
      ) : (
        <div className="text-center py-4">No user data available</div>
      )}
    </Modal>
  );
};
